import styled from 'styled-components/native'
import styledWeb from 'styled-components'

import { ButtonWithText } from '../App/Components'

export const ConfirmPageWrapper = styled.View`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ConfirmScrollArea = styled.ScrollView`
  flex: 1;
  padding: 16px;
`

export const ConfirmButtonFooter = styled.View`
  padding: 12px 16px;
  border-top-width: 1px;
  border-top-color: #e0e0e0;
`

export const ConfirmBookingButton = styledWeb(ButtonWithText)`
  border: none;
  transition: background-color 0.15s ease;
  &:hover {
    background-color: ${({ backgroundcolor }) =>
      `color-mix(in srgb, ${backgroundcolor} 90%, black)`};
  }
  & > span {
    font-weight: 700;
  }
`

export const LoginForPunchCardCheckButton = styledWeb(ButtonWithText)``
